import type {
    AiTrackerReportsSentimentAnalysisPromptsResponse,
    AiTrackerReportsSentimentAnalysisPromptResponseData,
} from "@similarweb/pro-api-client";

import type { ISentiment } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export enum SentimentTab {
    Positive = "positive",
    Neutral = "neutral",
    Negative = "negative",
}

export interface ITopicSentimentTableRow {
    topicName?: string;
    sentiment: ISentiment;
}

export interface ISentimentTabData {
    tabTextKey: string;
    badgeTextKey: string;
}

export type IPromptResponse = AiTrackerReportsSentimentAnalysisPromptResponseData;
export type ITopicPrompts = AiTrackerReportsSentimentAnalysisPromptsResponse;
